export enum ChatBotFeedbackError {
    Unrecoverable = "Unrecoverable",
    Email = "Email",
    Transcript = "Transcript",
}
